import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Partners from './components/Partners';
import Features from './components/Features';
import Traceability from './components/Traceability';
import Audit from './components/Audit';
import Analysis from './components/Analysis';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollReveal from './components/ScrollReveal';

function App() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <ScrollReveal><Partners /></ScrollReveal>
        <ScrollReveal><Features /></ScrollReveal>
        <ScrollReveal><Traceability /></ScrollReveal>
        <ScrollReveal><Analysis /></ScrollReveal>
        <ScrollReveal><Audit /></ScrollReveal>
        <ScrollReveal><Pricing /></ScrollReveal>
        <ScrollReveal><Testimonials /></ScrollReveal>
        <ScrollReveal><FAQ /></ScrollReveal>
        <ScrollReveal><Contact /></ScrollReveal>
      </main>
      <Footer />
    </div>
  );
}

export default App;
